<mat-card>
  @if (fullName$ | async; as fullName) {
    <mat-card-header
      [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null"
      >
      <!-- This must be a div or the matCardAvatar directive won't work -->
      @if (showAvatar) {
        <div matCardAvatar>
          @if ((showUnknownAvatar$ | async) === false) {
            <glxy-avatar
              [name]="fullName"
              [width]="AVATAR_WIDTH"
              [src]="(profileImageUrl$ | async) ?? ''"
            ></glxy-avatar>
          } @else {
            <crm-unknown-user-avatar [width]="AVATAR_WIDTH"></crm-unknown-user-avatar>
          }
        </div>
      }
      <mat-card-title>
        <span class="title">
          @if (fullName$ | async; as fullName) {
            <span class="full-name">{{ fullName }}</span>
          }
          @if (headerText$ | async; as headerText) {
            <span>{{ headerText | translate }}</span>
          }
          @if (showPrimaryAssociation) {
            @if (primaryAssociation(); as primaryAssociation) {
              <span class="association">
                {{ 'OBJECT_TYPES.FOR_LABEL' | translate }} {{ primaryAssociation.objectType || '' | translate }}
                <a [routerLink]="routePrefix() + '/' + primaryAssociation.linkUrl">{{ primaryAssociation.name }}</a>
              </span>
            }
          }
        </span>
      </mat-card-title>
      <mat-card-subtitle>
        @if (subtitleTemplate) {
          <div class="effective-date">
            <ng-container *ngTemplateOutlet="subtitleTemplate!"></ng-container>
          </div>
        } @else {
          @if (effectiveDate$ | async; as effectiveDate) {
            <p class="effective-date">
              {{ effectiveDate | date: dateFormat }}
            </p>
          }
        }
      </mat-card-subtitle>
      <ng-content select="[crmActivityTemplateOptions]"></ng-content>
    </mat-card-header>
  }
  <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 16).toString() + 'px'">
    <!-- align content with edge of avatar as AVATAR_WIDTH + padding of mat-card-title -->
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>



